type Environment = 'localhost' | 'staging' | 'production' | 'preview';

// Duplicated from apps/frontend on purpose: this package must stay independent of the host app.
function getEnvironment(): Environment {
  return window.location.hostname === 'app.e2n.de' ||
    window.location.hostname === 'manager.e2n.de'
    ? 'production'
    : window.location.hostname === 'staging.e2n.de' ||
        window.location.hostname === 'manager.staging.e2n.de'
      ? 'staging'
      : window.location.hostname === 'localhost'
        ? 'localhost'
        : 'preview';
}

const API_BASE_URL_PROD = 'https://api.manager.e2n.de/graphql';
const API_BASE_URL_STAGING = 'https://api.manager.staging.e2n.de/graphql';
const API_BASE_URL_LOCAL = 'http://localhost:8080/graphql';

export const apiBaseUrl =
  getEnvironment() === 'production'
    ? API_BASE_URL_PROD
    : getEnvironment() === 'staging'
      ? API_BASE_URL_STAGING
      : API_BASE_URL_LOCAL;

export const graphqlApiUrl = `${apiBaseUrl}/graphql`;

export const docsUrl = (uidZugang: string) =>
  `${apiBaseUrl}/docs/zugang/${uidZugang}`;
